export var themes = [
    {
        name: 'default',
        ioMode: {
            dark: {
                primary: {
                    background: '#0073aa',
                    color: 'white',
                    borderColor: '#0073aa',
                    hoverBGColor: '#fdfdfdf7',
                    checkMarkColor: 'red',
                    active: '#112469',
                    inkbar: 'deepskyblue',
                    inkbarShadow: '#070707d6',
                    footerbackground: '#0073aa',
                    textcolor: 'white',
                    attachmentBackground: '#f8fdff',
                    borderLeft: '#1ea2b8'
                },
                secondary: {
                    background: '#868e96',
                    color: 'white',
                    borderColor: '#868e96',
                    hoverBGColor: '#fdfdfdf7',
                    checkMarkColor: 'white',
                    active: '#595A5C',
                    inkbar: 'deepskyblue',
                    inkbarShadow: '#070707d6',
                    footerbackground: '#868e96',
                    textcolor: 'black',
                    attachmentBackground: '#fafafa',
                    borderLeft: '#1ea2b8'
                },
                success: {
                    background: '#28a745',
                    color: 'white',
                    borderColor: '#28a745',
                    hoverBGColor: '#fdfdfdf7',
                    checkMarkColor: 'green',
                    active: 'green',
                    inkbar: 'deepskyblue',
                    inkbarShadow: '#070707d6',
                    footerbackground: '#28a745',
                    textcolor: 'white',
                    attachmentBackground: '#e8faec',
                    borderLeft: '#1ea2b8'
                },
                info: {
                    background: '#1997c6',
                    color: 'white',
                    borderColor: '#1997c6',
                    hoverBGColor: '#fdfdfdf7',
                    checkMarkColor: 'pink',
                    active: '#112469',
                    inkbar: 'deepskyblue',
                    inkbarShadow: '#070707d6',
                    footerbackground: '#1997c6',
                    textcolor: 'black',
                    attachmentBackground: '#fafcfd',
                    borderLeft: '#1ea2b8'
                },
                warning: {
                    background: '#fdff00',
                    color: 'black',
                    borderColor: '#fdff00',
                    hoverBGColor: '#fdfdfdf7',
                    checkMarkColor: 'blue',
                    active: '#BCCA18',
                    inkbar: 'deepskyblue',
                    inkbarShadow: '#070707d6',
                    footerbackground: '#fdff00',
                    textcolor: 'black',
                    attachmentBackground: '#ffffeb',
                    borderLeft: '#1ea2b8'
                },
                danger: {
                    background: '#d9534f',
                    color: 'red',
                    borderColor: '#dc3545',
                    hoverBGColor: '#fdfdfdf7',
                    checkMarkColor: 'grey',
                    active: '#F9B89D',
                    inkbar: 'deepskyblue',
                    inkbarShadow: '#070707d6',
                    footerbackground: '#d9534f',
                    textcolor: 'white',
                    attachmentBackground: '#fcf1f0',
                    borderLeft: '#1ea2b8'
                },
                link: {
                    background: 'blue',
                    color: 'white',
                    borderColor: 'blue',
                    hoverBGColor: '#fdfdfdf7',
                    panel: 'azure',
                    menubackground: 'blue',
                    menucolor: 'white',
                    menuhoverbgcolor: '#fdfdfdf7',
                    menuhovercolor: ''
                }
            },
            light: {
                primary: {
                    background: '#3c8dbc',
                    color: 'white',
                    borderColor: '#3c8dbc',
                    hoverBGColor: '#fdfdfdf7',
                    tableBorderColor: '1px solid white',
                    tableBackground: '#e9f7fc',
                    tableHeaderColor: '#20a8d8',
                    tableAccentColor: '#bce6f5',
                    tableHoverColor: '#f2f2f2',
                    checkMarkColor: 'red',
                    active: '#112469',
                    inkbar: 'deepskyblue',
                    inkbarShadow: '#070707d6',
                    footerbackground: '#3c8dbc',
                    textcolor: 'white',
                    submenubackground: 'transparent',
                    attachmentBackground: '#f8fdff',
                    borderLeft: '#1ea2b8'
                },
                secondary: {
                    background: '#c8ced3',
                    color: 'white',
                    borderColor: '#c8ced3',
                    hoverBGColor: '#fdfdfdf7',
                    tableBorderColor: '1px solid White',
                    tableBackground: '#ffffff',
                    tableHeaderColor: '#394047',
                    tableAccentColor: '#ffffff',
                    tableHoverColor: '#f2f2f2',
                    checkMarkColor: 'white',
                    active: '#595A5C',
                    inkbar: 'deepskyblue',
                    inkbarShadow: '#070707d6',
                    footerbackground: '#c8ced3',
                    textcolor: 'black',
                    submenubackground: 'transparent',
                    attachmentBackground: '#fafafa',
                    borderLeft: '#1ea2b8'
                },
                success: {
                    background: '#4dbd74',
                    color: 'white',
                    borderColor: '#4dbd74',
                    hoverBGColor: '#fdfdfdf7',
                    tableBorderColor: '1px solid White',
                    tableBackground: '#ecf8f0',
                    tableHeaderColor: '#30824d',
                    tableAccentColor: '#daf1e2',
                    tableHoverColor: '#f2f2f2',
                    checkMarkColor: 'green',
                    active: 'green',
                    inkbar: 'deepskyblue',
                    inkbarShadow: '#070707d6',
                    footerbackground: '#4dbd74',
                    textcolor: 'white',
                    submenubackground: 'transparent',
                    attachmentBackground: '#e8faec',
                    borderLeft: '#1ea2b8'
                },
                info: {
                    background: '#004269',
                    color: 'white',
                    borderColor: '#004269',
                    hoverBGColor: '#fdfdfdf7',
                    tableBorderColor: '1px solid white',
                    tableBackground: '#daf2e6',
                    tableHeaderColor: '#004269',
                    tableAccentColor: '#e6fff2',
                    tableHoverColor: '#f2f2f2',
                    checkMarkColor: 'pink',
                    active: '#112469',
                    inkbar: 'deepskyblue',
                    inkbarShadow: '#070707d6',
                    footerbackground: '#004269',
                    textcolor: 'white',
                    submenubackground: 'transparent',
                    attachmentBackground: '#f4fbfe',
                    borderLeft: '#1ea2b8'
                },
                warning: {
                    background: '#ffc107',
                    color: 'white',
                    borderColor: '#ffc107',
                    hoverBGColor: '#fdfdfdf7',
                    tableBorderColor: '1px solid white',
                    tableBackground: '#f2e0aa',
                    tableHeaderColor: '#cc9900',
                    tableAccentColor: '#ffecb3',
                    tableHoverColor: '#f2f2f2',
                    checkMarkColor: 'blue',
                    active: '#BCCA18',
                    inkbar: 'deepskyblue',
                    inkbarShadow: '#070707d6',
                    footerbackground: '#ffc107',
                    textcolor: 'black',
                    submenubackground: 'transparent',
                    attachmentBackground: '#ffffeb', borderLeft: '#1ea2b8'
                },
                danger: {
                    background: '#f86c6b',
                    color: 'red',
                    borderColor: '#f86c6b',
                    hoverBGColor: '#fdfdfdf7',
                    tableBorderColor: '1px solid white',
                    tableBackground: '#fee7e7',
                    tableHeaderColor: '#c30909',
                    tableAccentColor: '#fee7e7',
                    tableHoverColor: '#f2f2f2',
                    checkMarkColor: 'grey',
                    active: '#F9B89D',
                    inkbar: 'deepskyblue',
                    inkbarShadow: '#070707d6',
                    footerbackground: '#f86c6b',
                    textcolor: 'white',
                    submenubackground: 'transparent',
                    attachmentBackground: '#fcf1f0', borderLeft: '#1ea2b8'
                },
                link: {
                    background: 'blue',
                    color: 'white',
                    hoverBGColor: '#fdfdfdf7'
                }
            }
        },
        uiLibrary: 'bootstrap'
    },
    {
        name: 'mugreen',
        ioMode: {
            light: {
                primary: {
                    background: 'green',
                    color: 'white'
                }
            },
            light1: {
                primary: {
                    background: '#6f42c1',
                    color: 'red'
                }
            }
        },
        uiLibrary: 'materialui'
    }
];
export var resolveColor = function (theme, mode, styleName, attribute) {
    return theme.ioMode[mode][styleName ? styleName : 'primary'][attribute];
};
export var resolver = function (enable, theme, mode, styleName, attribute) {
    return enable
        ? theme.ioMode[mode][styleName ? styleName : 'primary'][attribute]
        : '';
};
//# sourceMappingURL=ThemeOptions.js.map